import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "@/components/site/Page";
import { PrivacyPolicyContent } from "@/components/site/EnrollmentPolicyContent";
import { seoLinks, ogImage } from "@/lib/seo";

const TITLE = "Política de privacidad | Swedish International School";
const DESCRIPTION =
  "Cómo Swedish International School trata los datos personales de alumnos, familias y visitantes de la web conforme al RGPD.";

export const Route = createFileRoute("/es/politica-de-privacidad")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/politica-de-privacidad"),
  }),
  component: PoliticaPrivacidad,
});

function PoliticaPrivacidad() {
  return (
    <>
      <PageHero
        eyebrow="Legal"
        title="Política de privacidad"
        intro="Tratamos los datos personales con cuidado y solo para las finalidades descritas aquí."
      />

      <PolicyBody>
        <PrivacyPolicyContent locale="es" />
      </PolicyBody>
      <div className="h-20" />
    </>
  );
}
